import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register/index.vue'),
    // meta: {
    //   keepAlive: true
    // }
  },
  {
    path: '/',
    name: 'layout',
    component: () => import('../views/layout/index.vue'),
    children: [
      {
        path: '/',
        name: 'login',
        component: () => import('../views/login/index.vue'),
        meta: {
          keepAlive: true
        }
      }]
  },
  {
    path: '/',
    name: 'layoutHome',
    component: () => import('../views/layoutHome/index.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        // meta: {
        //   keepAlive: true
        // }
      },
      {
        path: '/qrcode',
        name: 'qrcode',
        component: () => import('../views/home/qrcode.vue'),
        // meta: {
        //   keepAlive: true
        // }
      },
      {
        path: '/my',
        name: 'my',
        component: () => import('../views/my/index.vue'),
        // meta: {
        //   keepAlive: true
        // }
      },
      {
        path: '/addAddress',
        name: 'addAddress',
        component: () => import('../views/addAddress/index.vue'),
        // meta: {
        //   keepAlive: true
        // }
      },
      {
        path: '/address',
        name: 'address',
        component: () => import('../views/address/index.vue'),
        // meta: {
        //   keepAlive: true
        // }
      },
      {
        path: '/myProfile',
        name: 'myProfile',
        component: () => import('../views/myProfile/index.vue'),
        // meta: {
        //   keepAlive: true
        // }
      }]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
